import * as React from "react";
import styles from "./NumericTextbox.scss";

export interface IProps {
    onChange: (newValue: number) => void;
    value?: number;
    className?: string;
    min?: number;
    max?: number;
    allowEmpty?: boolean;
}

interface IState {
    value?: number;
    isFocussed: boolean;
}

export class NumericTextbox extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            value: this.checkNewValue(props.value),
            isFocussed: false
        };

        this.onChange = this.onChange.bind(this);
    }

    private checkNewValue(newValue?: number): number | undefined {
        if (this.props.min !== undefined && newValue && newValue < this.props.min) {
            return this.props.min;
        }

        if (this.props.max !== undefined && newValue && newValue > this.props.max) {
            return this.props.max;
        }

        return newValue;
    }

    public onChange(event: React.FormEvent<HTMLTextAreaElement>) {
        let newValue = parseInt(event.currentTarget.value, undefined);
        if (!isNaN(newValue) || this.props.allowEmpty) {
            newValue = this.checkNewValue(newValue)!;

            this.setState({
                value: newValue
            });

            if (this.props.onChange) {
                this.props.onChange(newValue);
            }
        }
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.value !== prevState.value) {
            partialState.value = nextProps.min !== undefined && nextProps.value && nextProps.min > nextProps.value ? nextProps.min : nextProps.value;
        }

        if (nextProps.value !== prevState.value) {
            partialState.value = nextProps.max !== undefined && nextProps.value && nextProps.max < nextProps.value ? nextProps.max : partialState.value !== undefined ? partialState.value : nextProps.value;
        }

        return partialState;
    }

    public render() {
        return (
            <input className={`${styles.numericTextBox} ${this.props.className}`} type="number" min={this.props.min} max={this.props.max} value={!this.state.value && this.state.value !== 0 ? "" : this.state.value} onChange={this.onChange} />
        );
    }
}

export default NumericTextbox;


// WEBPACK FOOTER //
// ./src/Components/Common/Input/TextBoxes/NumericTextbox.tsx